/**
 * Единственная точка hard-навигации (прямой смены window.location.href) для
 * флоу, где SPA-navigate не подходит: 401-редирект на логин из axios-интерсепторов
 * (вне React-дерева) и уход на внешний IdP при SSO.
 *
 * Объект-обёртка вместо голой функции — шов для тестов: window.location в jsdom
 * unforgeable (замокать нельзя), а spyOn(hardNavigation, "assign") работает.
 */
export const hardNavigation = {
  assign(href: string): void {
    window.location.href = href;
  },
};
